import * as ambassadorWixInnovationWidgetV1Conversation from './innovation-widget-v1-conversation-conversations.http.js';
import * as ambassadorWixInnovationWidgetV1ConversationTypes from './innovation-widget-v1-conversation-conversations.types.js';
import * as ambassadorWixInnovationWidgetV1ConversationUniversalTypes from './innovation-widget-v1-conversation-conversations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getConversation(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInnovationWidgetV1ConversationUniversalTypes.GetConversationRequest,
  ambassadorWixInnovationWidgetV1ConversationTypes.GetConversationRequest,
  ambassadorWixInnovationWidgetV1ConversationUniversalTypes.GetConversationResponse,
  ambassadorWixInnovationWidgetV1ConversationTypes.GetConversationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInnovationWidgetV1Conversation.getConversation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/conversation',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Conversation as ConversationOriginal,
  ConversationParticipantIdOneOf as ConversationParticipantIdOneOfOriginal,
  GetConversationRequest as GetConversationRequestOriginal,
  GetConversationResponse as GetConversationResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './innovation-widget-v1-conversation-conversations.types.js';
